import React from 'react';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import { makeStyles, TableContainer } from '@material-ui/core';
import TableBody from '@material-ui/core/TableBody';
import TableHead from '@material-ui/core/TableHead';
import Table from '@material-ui/core/Table';

const useStyles = makeStyles(theme => ({
    table: {
        margin: 0,
    },
    tableRow: {
        '&:nth-of-type(odd)': {
            backgroundColor: 'rgb(245, 248, 255)'
        },
        borderBottom: 'transparent',
    },
    tableCell: {
        borderBottom: 'none',
    },
}))

const CustomTableRow = ({ row }) => {
    const classes = useStyles()
    const percent = Number(row.percent ?? 0)
    const value = Number(row.value ?? 0)

    if (row.current_user) {
        return (
            <TableRow className={classes.tableRow}>
                <TableCell className={classes.tableCell} component="th" scope="row">
                    <strong>Your rank {percent}%</strong>
                </TableCell>
                <TableCell className={classes.tableCell}>
                    <strong>{value}</strong>
                </TableCell>
            </TableRow>
        )
    }

    return (
        <TableRow className={classes.tableRow}>
            <TableCell className={classes.tableCell} component="th" scope="row">
                Top {percent}%
            </TableCell>
            <TableCell className={classes.tableCell}>{value}</TableCell>
        </TableRow>
    )
}

const DrawerIndustryBreakdownTable = ({ industryBreakdown }) => {
    const classes = useStyles()

    return (
        <TableContainer>
            <Table className={classes.table} >
                <TableHead>
                    <TableRow>
                        <TableCell className={classes.tableCell}>Industry benchmark</TableCell>
                        <TableCell className={classes.tableCell}>Question score</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {industryBreakdown.map((row) => (
                        <CustomTableRow row={row} key={`${row.current_user}-${row.percent}-${row.value}`}/>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    )
}

export default (DrawerIndustryBreakdownTable)